module.exports = __webpack_public_path__ + "img/shape-8-mobile-gold@2x.d4de48fa.png";